import * as React from 'react';
import {
  Routes,
  Route,
  Link as LinkRoute,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';

import HomeIcon from '@mui/icons-material/Home';

import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import ArtTrackSharpIcon from '@mui/icons-material/ArtTrackSharp';
import ImageAspectRatioSharpIcon from '@mui/icons-material/ImageAspectRatioSharp';
import MapSharpIcon from '@mui/icons-material/MapSharp';

// import Title from '../moto/Title';

// import { preProcessFile } from 'typescript';

import useLocalStorageState from 'use-local-storage-state'


import MotoPage from './MotoPage';
// import Copyright from '../Copyright'
import PrAvOrd from './components/PrAvOrd';
import {useAuth} from '../context/AuthContext'

import { CartWidget } from '../components/CartWidget'
import { PrCartProps } from '../components/Products'
import { PrCart  } from '../components/Cart';

import PrOrders from './components/PrOrders'

import PrFisses from './components/PrFisses'


import {PrAvProvider, PrAvContext, usePrAvcontext} from '../context/PrAVContext'
import {PrFissesProvider, PrFissesContext, usePrFissescontext} from '../context/PrFissesContext'

import theme from '../theme';

import { returnBasenameUrl } from '../utils';

const drawerWidth: number = 240;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));
  
  const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );
  
  // TODO remove, this demo shouldn't need to reset the theme.
  // const defaultTheme = createTheme();
  
  
  const dbact_prav =       {action: 'prav', title:'Διαθεσιμότητα ανταλλακτικού' }
  const dbact_prfisses =   {action: 'prfisses', title:'Διαφάνειες ανταλλακτικών'}
  const dbact_prcart =     {action: 'prcart', title:'Καλάθι παραγγελίας ανταλλακτικών'}
  const dbact_prorders =   {action: 'prav-orders', title:'Οι παραγγελίες μου ανταλλακτικών'}
    
  export default function PartsDashboard() {
    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuth();
    let prcntxt = usePrAvcontext();

    let prfissescntxt=usePrFissescontext();

    const [open, setOpen] = React.useState(true);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const [dashbaction, setDashbaction ] = React.useState(dbact_prav)
    
    const [prcart,] = useLocalStorageState<PrCartProps>(`${process.env.REACT_APP_PRCARTKEYNAME}`, {})
    const productsCount: number = Object.keys(prcart || {}).length

    function navigateToCart(){
      setDashbaction(dbact_prcart)
    }

    // console.log("Dashboard dashbaction", dashbaction)
  
    React.useEffect( () => {
      console.log("PartsDashboard useEffect[] prcntxt", prcntxt,'prfissescntxt',prfissescntxt)
      let basename=returnBasenameUrl()
      let url =`${basename}${process.env.REACT_APP_B2B_API_URL}`;
      if(prcntxt.prContextData === undefined || prcntxt.prContextData === null || prcntxt.prContextData.success===undefined  || 
        prcntxt.prContextData.success===null ||  prcntxt.prContextData.success===false ){
        prcntxt.setpravcontext();
      }
      // if(prfissescntxt.prfissescontextdata === undefined || prfissescntxt.prfissescontextdata === null || prfissescntxt.prfissescontextdata.success===undefined  || 
      //   prfissescntxt.prfissescontextdata.success===null ||  prfissescntxt.prfissescontextdata.success===false ){
      //     prfissescntxt.setprfissescontext();
      // }
      prfissescntxt.setprfissescontext();
    },[] );	
  
    React.useEffect( () => {
    },[dashbaction] );
  
    function setDashBAction( dhb:{action:string, title:string} ){
      setDashbaction(dhb)
    }
  
    return (        
        <Box id="boxbefappbar1" sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar id="appbar1" position="absolute" open={open}>
            <Toolbar id="toolabr-in-appbar1"
              sx={{
                pr: '24px', // keep right padding when drawer closed
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                sx={{
                  marginRight: '36px',
                  ...(open && { display: 'none' }),
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
              >
                {dashbaction.title}
              </Typography>

              <CartWidget productsCount={productsCount} navigatetocart={navigateToCart} />
              {/* <IconButton color="inherit">
                <Badge badgeContent={4} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton> */}

            </Toolbar>
          </AppBar>
          <Drawer variant="permanent" open={open}>
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
              }}
            >
              <IconButton onClick={toggleDrawer}>
                Ανταλλακτικά <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List component="nav">

              <Tooltip title="Διαθεσιμότητα" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_prav) } }>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Διαθεσιμότητα" />
              </ListItemButton>
              </Tooltip>

              <Tooltip title="Διαφάνειες" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_prfisses) } }>
                <ListItemIcon>
                <ImageAspectRatioSharpIcon />
                </ListItemIcon>
                <ListItemText primary="Διαφάνειες" />
              </ListItemButton>
              </Tooltip>

              <Tooltip title="Καλάθι παραγγελίας" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_prcart) } }>
                <ListItemIcon>
                <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText primary="Καλάθι παραγγελίας" />
              </ListItemButton>
              </Tooltip>

              <Tooltip title="Οι Παραγγελίες μου" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_prorders) } } >
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText primary="Οι Παραγγελίες μου" />
              </ListItemButton>
              </Tooltip>

              <Divider sx={{ my: 1 }} />
              {/* {secondaryListItems} */}
  
              <Tooltip title="Αρχή" placement="bottom">
              <ListItemButton onClick={(e)=>{ navigate("/", { replace: true })} }>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Αρχή" />
              </ListItemButton>
              </Tooltip>
  
            </List>
          </Drawer>
         
          <Box component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            {/* <Toolbar /> */}
            {prcntxt.prContextData.success===true &&
            <Container id="pr-container" maxWidth="lg" sx={{ mt: 2, mb: 4, ml:0 }}>            
              {/* <Box><Typography variant="h5" component="h5">{dashbaction.title}</Typography></Box> */}

              {{
                'prav': <PrAvOrd />,
                'prfisses': <PrFisses />,
                'prcart': <PrCart />,
                'prav-orders': <PrOrders />,
              }[dashbaction.action]}
            
              {/* <Copyright sx={{ pt: 4 }} /> */}  
            </Container>
            }
            {(prcntxt.prContextData === undefined || prcntxt.prContextData === null || prcntxt.prContextData.success===undefined  || 
            prcntxt.prContextData.success===null ||  prcntxt.prContextData.success===false ) &&
            <Typography>Loading Part Parameters ... </Typography>
            }

          </Box>
  
        </Box>
              
    );
  }
  